"use client";
import {InlineFilter} from "@/components/@filter/inline-filter";
import {NeoModal} from "@/components/@modal/neo.modal";
import {DownloadIcon} from "@/components/shared";
import {useNeoContext} from "@/context/neo/neo.context";
import {downloadCSV} from "@/libs/helper";
import {creaditOverview} from "@/service/routePlan.service";
import {Spinner} from "@nextui-org/react";
import Image from "next/image";
import {useMemo, useState} from "react";
import {AiOutlineFileSearch} from "react-icons/ai";
type ActivityItem = {
  id: string;
  type: string;
  title: string;
  subtitle: string;
  time: string;
  user: string;
  credits: number;
  accent: string;
};
type Summary = {
  usageBreakDowns: {
    name: string;
    usage: number;
  }[];
  creditOverview: {
    usedCredits: number;
    remaining: number;
  };
};
export const CreditsPointsUsages = () => {
  const {filterContext, offset} = useNeoContext();
  const [loginUserId, setLoginUserId] = useState<string>("");
  const [actionType, setActionType] = useState<any | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState<ActivityItem[] | []>([]);
  const [downloadData, setDownloadData] = useState([]);
  const [summary, setSummary] = useState<Summary>({
    usageBreakDowns: [
      {name: "Vahan Fetch", usage: 0},
      {name: "Route Plan", usage: 0}
    ],
    creditOverview: {
      usedCredits: 0,
      remaining: 0
    }
  });
  const fetchLogsByFilter = async (request: {from: number; to: number}) => {
    setLoading(true);
    await creaditOverview
      .getCreditOverview(request)
      .then((response: any) => {
        if (response) {
          // console.log("Log Info", response);
          setLogs(response.reportData);
          setSummary(response.summary);
          setDownloadData(response.reportDataDownload);
          // setRouteGpsLocations(response);
        } else {
          //setRouteGpsLocations([] as any);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const filteredLogs = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    return logs.filter((l: any) =>
      [l.title, l.user, l.subtitle].some(f =>
        (f ?? "").toLowerCase().includes(q)
      )
    );
  }, [logs, searchQuery]);

  const totalPages = Math.ceil(filteredLogs.length / pageSize);

  const paginatedLogs = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredLogs.slice(start, start + pageSize);
  }, [filteredLogs, currentPage, pageSize]);

  function LogRow({log}: {log: any}) {
    return (
      <div className="group flex items-center gap-3 p-2">
        <div
          className={`items-center justify-center rounded-full p-4 ${
            log.type === "Route Plan" ? "bg-[#FFC727]/10" : "bg-[#DBEAFE]"
          }`}
          aria-hidden
        >
          {log.type === "Route Plan" ? (
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.8434 4.23284C17.8434 5.94173 15.8315 8.49144 14.9634 9.50929C14.8341 9.65907 14.6435 9.71694 14.4698 9.6795H11.3074C10.7048 9.6795 10.218 10.1663 10.218 10.7688C10.218 11.3714 10.7048 11.8582 11.3074 11.8582H14.5754C16.3796 11.8582 17.8434 13.3219 17.8434 15.1262C17.8434 16.9304 16.3796 18.3941 14.5754 18.3941H5.16627C5.46243 18.0571 5.82328 17.6248 6.18752 17.1414C6.40198 16.8555 6.62325 16.5423 6.83431 16.2155H14.5754C15.1779 16.2155 15.6647 15.7287 15.6647 15.1262C15.6647 14.5236 15.1779 14.0368 14.5754 14.0368H11.3074C9.50317 14.0368 8.03938 12.573 8.03938 10.7688C8.03938 8.96462 9.50317 7.50083 11.3074 7.50083H12.6622C11.9474 6.42852 11.3074 5.19622 11.3074 4.23284C11.3074 2.42863 12.7712 0.964844 14.5754 0.964844C16.3796 0.964844 17.8434 2.42863 17.8434 4.23284ZM4.40034 17.6146C4.27098 17.761 4.15524 17.8903 4.05652 17.9993L3.99524 18.0674L3.98843 18.0605C3.78418 18.2171 3.49142 18.1967 3.3076 17.9993C2.44975 17.0665 0.414062 14.6666 0.414062 12.9475C0.414062 11.1433 1.87785 9.6795 3.68206 9.6795C5.48626 9.6795 6.95005 11.1433 6.95005 12.9475C6.95005 13.9687 6.23177 15.2283 5.46924 16.2802C5.105 16.7806 4.73054 17.2333 4.42076 17.5908L4.40034 17.6146ZM4.77139 12.9475C4.77139 12.6586 4.65662 12.3815 4.45233 12.1772C4.24804 11.9729 3.97097 11.8582 3.68206 11.8582C3.39315 11.8582 3.11607 11.9729 2.91178 12.1772C2.70749 12.3815 2.59273 12.6586 2.59273 12.9475C2.59273 13.2364 2.70749 13.5135 2.91178 13.7178C3.11607 13.9221 3.39315 14.0368 3.68206 14.0368C3.97097 14.0368 4.24804 13.9221 4.45233 13.7178C4.65662 13.5135 4.77139 13.2364 4.77139 12.9475ZM14.5754 5.32217C14.8643 5.32217 15.1414 5.2074 15.3456 5.00311C15.5499 4.79882 15.6647 4.52175 15.6647 4.23284C15.6647 3.94393 15.5499 3.66685 15.3456 3.46256C15.1414 3.25828 14.8643 3.14351 14.5754 3.14351C14.2865 3.14351 14.0094 3.25828 13.8051 3.46256C13.6008 3.66685 13.486 3.94393 13.486 4.23284C13.486 4.52175 13.6008 4.79882 13.8051 5.00311C14.0094 5.2074 14.2865 5.32217 14.5754 5.32217Z"
                fill="#FFC727"
              />
            </svg>
          ) : (
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.12872 0.476562C13.7039 0.476562 16.754 1.67483 16.754 3.19989V3.74456V4.83389C17.3566 4.83389 17.8434 5.32068 17.8434 5.92322V8.10188C17.8434 8.70442 17.3566 9.19122 16.754 9.19122V14.6379C16.754 15.2404 16.2672 15.7272 15.6647 15.7272V16.8165C15.6647 17.4191 15.1779 17.9059 14.5754 17.9059H13.486C12.8835 17.9059 12.3967 17.4191 12.3967 16.8165V15.7272H5.86072V16.8165C5.86072 17.4191 5.37393 17.9059 4.77139 17.9059H3.68206C3.07952 17.9059 2.59273 17.4191 2.59273 16.8165V15.7272C1.99019 15.7272 1.50339 15.2404 1.50339 14.6379V9.19122C0.900858 9.19122 0.414062 8.70442 0.414062 8.10188V5.92322C0.414062 5.32068 0.900858 4.83389 1.50339 4.83389V3.74456V3.19989C1.50339 1.67483 4.55352 0.476562 9.12872 0.476562ZM3.68206 5.92322V9.19122C3.68206 9.79375 4.16885 10.2805 4.77139 10.2805H8.58405V4.83389H4.77139C4.16885 4.83389 3.68206 5.32068 3.68206 5.92322ZM9.67338 10.2805H13.486C14.0886 10.2805 14.5754 9.79375 14.5754 9.19122V5.92322C14.5754 5.32068 14.0886 4.83389 13.486 4.83389H9.67338V10.2805ZM4.22672 14.0932C4.51563 14.0932 4.79271 13.9784 4.997 13.7741C5.20129 13.5699 5.31605 13.2928 5.31605 13.0039C5.31605 12.715 5.20129 12.4379 4.997 12.2336C4.79271 12.0293 4.51563 11.9145 4.22672 11.9145C3.93781 11.9145 3.66074 12.0293 3.45645 12.2336C3.25216 12.4379 3.13739 12.715 3.13739 13.0039C3.13739 13.2928 3.25216 13.5699 3.45645 13.7741C3.66074 13.9784 3.93781 14.0932 4.22672 14.0932ZM14.0307 14.0932C14.3196 14.0932 14.5967 13.9784 14.801 13.7741C15.0053 13.5699 15.12 13.2928 15.12 13.0039C15.12 12.715 15.0053 12.4379 14.801 12.2336C14.5967 12.0293 14.3196 11.9145 14.0307 11.9145C13.7418 11.9145 13.4647 12.0293 13.2604 12.2336C13.0561 12.4379 12.9414 12.715 12.9414 13.0039C12.9414 13.2928 13.0561 13.5699 13.2604 13.7741C13.4647 13.9784 13.7418 14.0932 14.0307 14.0932ZM12.3967 3.19989C12.3967 2.90033 12.1516 2.65523 11.852 2.65523H6.40539C6.10582 2.65523 5.86072 2.90033 5.86072 3.19989C5.86072 3.49946 6.10582 3.74456 6.40539 3.74456H11.852C12.1516 3.74456 12.3967 3.49946 12.3967 3.19989Z"
                fill="#2563EB"
              />
            </svg>
          )}
        </div>
        <div className="flex-1 rounded-xl bg-[#F9FAFB] p-4">
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-[13px] font-semibold text-gray-900">
                  {log.type}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="truncate text-[13px] text-gray-600">
                  {log.title}
                </span>
              </div>
              <div className="mt-0.5 text-xs text-gray-500">{log.subtitle}</div>
            </div>
            <span
              className={`inline-block rounded-full px-2 py-0.5 text-xs font-bold ${
                log.type === "Route Plan"
                  ? "bg-yellow-100 text-yellow-700"
                  : "bg-blue-100 text-blue-700"
              }`}
            >
              {log.credits} credits
            </span>
          </div>
        </div>
      </div>
    );
  }

  const creditspointform = () => {
    setActionType("creditspointform");
    setModalOpen(true);
  };

  const onModalSubmit = () => {};

  const onModalClose = async () => {
    setModalOpen(false);
  };
  const onExportClick = () => {
    const fileName = `creditPointUsage-${new Date().toISOString().slice(0, 10)}`;
    downloadCSV(downloadData, fileName);
  };
  return (
    <>
      <>
        <div className="w-full bg-white">
          <div className="w-full px-4 py-5">
            <div className="grid grid-cols-12 gap-6">
              <div className="col-span-12 lg:col-span-6 xl:col-span-8">
                <div className="mb-4 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <InlineFilter onFilterChange={fetchLogsByFilter} />
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Search"
                        className="h-9 w-56 rounded-lg border border-gray-200 pl-9 pr-3 text-sm placeholder:text-gray-400 focus:border-gray-400 focus:outline-none"
                        value={searchQuery}
                        onChange={e => {
                          setSearchQuery(e.target.value);
                          setCurrentPage(1);
                        }}
                      />
                      <svg
                        viewBox="0 0 24 24"
                        className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
                      >
                        <path
                          d="M21 21l-4.3-4.3M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15z"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    {downloadData && (
                      <div
                        className="cursor-pointer px-2"
                        onClick={onExportClick}
                      >
                        <DownloadIcon />
                      </div>
                    )}
                  </div>
                </div>
                <div className="h-[calc(100vh-320px)] overflow-y-auto pr-2">
                  {loading ? (
                    <div className="flex items-center justify-center">
                      <Spinner color="default" />
                    </div>
                  ) : (
                    <>
                      {paginatedLogs.map((log: any, logindex: any) => (
                        <LogRow key={log.any} log={log} />
                      ))}
                    </>
                  )}
                  {!loading && paginatedLogs.length === 0 && (
                    <div className="flex h-full w-full flex-col items-center justify-center pt-7 text-center">
                      {/* Icon */}
                      <div className="mb-4">
                        <AiOutlineFileSearch size={48} className="" />
                      </div>

                      {/* Title */}
                      <h2 className="text-lg font-semibold text-gray-800">
                        No record found
                      </h2>

                      {/* Description */}
                      <p className="mt-1 text-sm text-gray-500">
                        Please adjust your filters or date range to view credit
                        usage.
                      </p>
                    </div>
                  )}
                </div>
                <div className="mt-4 flex flex-wrap items-center justify-end gap-4">
                  <div className="flex items-center gap-2 text-xs">
                    <span>Page Size</span>
                    <select
                      value={pageSize}
                      onChange={e => {
                        setPageSize(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                      className="h-8 rounded-lg border bg-white px-2"
                    >
                      {[10, 20, 50].map(size => (
                        <option key={size}>{size}</option>
                      ))}
                    </select>
                    <span>
                      {(currentPage - 1) * pageSize + 1} –{" "}
                      {Math.min(currentPage * pageSize, filteredLogs.length)} of{" "}
                      {filteredLogs.length}
                    </span>
                  </div>
                  <div className="flex items-center gap-1">
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(1)}
                      className="h-8 w-8 rounded-lg text-xs text-gray-600 hover:bg-gray-50 disabled:opacity-30"
                    >
                      |&lt;
                    </button>
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                      className="h-8 w-8 rounded-lg text-xs text-gray-600 hover:bg-gray-50 disabled:opacity-30"
                    >
                      &lt;
                    </button>
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() =>
                        setCurrentPage(p => Math.min(p + 1, totalPages))
                      }
                      className="h-8 w-8 rounded-lg text-xs text-gray-600 hover:bg-gray-50 disabled:opacity-30"
                    >
                      &gt;
                    </button>
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(totalPages)}
                      className="h-8 w-8 rounded-lg text-xs text-gray-600 hover:bg-gray-50 disabled:opacity-30"
                    >
                      &gt;|
                    </button>
                  </div>
                </div>
              </div>
              {/* Right: Sidebar */}
              <div className="col-span-12 lg:col-span-6 xl:col-span-4">
                <div className="rounded-2xl border border-gray-200 p-4">
                  <h3 className="mb-3 text-sm font-semibold text-gray-700">
                    Credits Overview
                  </h3>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="rounded-xl border border-[#FED7AA] bg-[#FFF7ED] p-5 text-center">
                      <div className="inline-flex rounded-lg bg-[#FED7AA] p-2">
                        <svg
                          width="17"
                          height="14"
                          viewBox="0 0 17 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.82812 1C2.82812 0.446875 2.38125 0 1.82812 0C1.275 0 0.828125 0.446875 0.828125 1V11.5C0.828125 12.8813 1.94687 14 3.32812 14H15.8281C16.3813 14 16.8281 13.5531 16.8281 13C16.8281 12.4469 16.3813 12 15.8281 12H3.32812C3.05312 12 2.82812 11.775 2.82812 11.5V1ZM15.5344 3.70625C15.925 3.31563 15.925 2.68125 15.5344 2.29063C15.1438 1.9 14.5094 1.9 14.1187 2.29063L10.8281 5.58437L9.03438 3.79063C8.64375 3.4 8.00938 3.4 7.61875 3.79063L4.11875 7.29062C3.72813 7.68125 3.72813 8.31563 4.11875 8.70625C4.50938 9.09688 5.14375 9.09688 5.53438 8.70625L8.32812 5.91563L10.1219 7.70938C10.5125 8.1 11.1469 8.1 11.5375 7.70938L15.5375 3.70937L15.5344 3.70625Z"
                            fill="#F97316"
                          />
                        </svg>
                      </div>
                      <div className="mt-2 text-2xl font-semibold text-gray-900">
                        {summary.creditOverview.usedCredits}
                      </div>
                      <div className="text-xs text-gray-500">Used Credits</div>
                    </div>
                    <div className="rounded-xl border border-[#BBF7D0] bg-[#F0FDF4] p-5 text-center">
                      <div className="inline-flex rounded-lg bg-[#BBF7D0] p-2">
                        <svg
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.5 2.5C16.5 3.0625 16.0531 3.58125 15.3 4C14.3906 4.50313 13.0344 4.85938 11.4781 4.96562C11.3625 4.90937 11.2469 4.85625 11.125 4.80937C9.89375 4.29375 8.25625 4 6.5 4C6.24062 4 5.9875 4.00625 5.73438 4.01875L5.7 4C4.94687 3.58125 4.5 3.0625 4.5 2.5C4.5 1.11875 7.1875 0 10.5 0C13.8125 0 16.5 1.11875 16.5 2.5ZM5.52187 5.03438C5.84062 5.0125 6.16875 5 6.5 5C8.44375 5 10.1687 5.38437 11.2656 5.98125C12.0406 6.40312 12.5 6.92812 12.5 7.5C12.5 7.625 12.4781 7.74687 12.4344 7.86562C12.2906 8.27812 11.9031 8.65625 11.3406 8.975C11.3375 8.97813 11.3313 8.97812 11.3281 8.98125C11.3188 8.9875 11.3094 8.99062 11.3 8.99687C10.2063 9.60312 8.4625 9.99687 6.5 9.99687C4.6375 9.99687 2.97187 9.64375 1.86875 9.0875C1.80937 9.05937 1.75312 9.02812 1.69687 8.99687C0.946875 8.58125 0.5 8.0625 0.5 7.5C0.5 6.4125 2.16875 5.48438 4.5 5.14375C4.82812 5.09688 5.16875 5.05938 5.52187 5.03438ZM13.5 7.5C13.5 6.81563 13.1687 6.25313 12.7469 5.83125C13.6312 5.69375 14.4406 5.475 15.1281 5.19063C15.6375 4.97813 16.1125 4.71563 16.5 4.39375V5.5C16.5 6.10313 15.9844 6.65937 15.1313 7.09062C14.675 7.32187 14.1187 7.51875 13.4937 7.66875C13.4969 7.6125 13.5 7.55938 13.5 7.50313V7.5ZM12.5 10.5C12.5 11.0625 12.0531 11.5813 11.3 12C11.2438 12.0312 11.1875 12.0594 11.1281 12.0906C10.0281 12.6469 8.3625 13 6.5 13C4.5375 13 2.79375 12.6062 1.7 12C0.946875 11.5813 0.5 11.0625 0.5 10.5V9.39375C0.890625 9.71562 1.3625 9.97813 1.87188 10.1906C3.10625 10.7063 4.74375 11 6.5 11C8.25625 11 9.89375 10.7063 11.1281 10.1906C11.3719 10.0906 11.6062 9.975 11.8281 9.85C12.0188 9.74375 12.1969 9.625 12.3656 9.5C12.4125 9.46562 12.4563 9.42813 12.5 9.39375V9.5V9.67813V10.5ZM13.5 10.5V9.5V8.69063C14.0938 8.55937 14.6406 8.39375 15.1281 8.19063C15.6375 7.97813 16.1125 7.71563 16.5 7.39375V8.5C16.5 8.82812 16.3438 9.15625 16.0344 9.46562C15.525 9.975 14.6281 10.3937 13.4937 10.6656C13.4969 10.6125 13.5 10.5562 13.5 10.5ZM6.5 14C8.25625 14 9.89375 13.7063 11.1281 13.1906C11.6375 12.9781 12.1125 12.7156 12.5 12.3938V13.5C12.5 14.8813 9.8125 16 6.5 16C3.1875 16 0.5 14.8813 0.5 13.5V12.3938C0.890625 12.7156 1.3625 12.9781 1.87188 13.1906C3.10625 13.7063 4.74375 14 6.5 14Z"
                            fill="#22C55E"
                          />
                        </svg>
                      </div>
                      <div className="mt-2 text-2xl font-semibold text-gray-900">
                        {summary.creditOverview.remaining}
                      </div>
                      <div className="text-xs text-gray-500">Remaining</div>
                    </div>
                  </div>
                  <button
                    className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-black"
                    onClick={creditspointform}
                  >
                    <Image
                      alt="coin"
                      src="/icons/routePlan/routePlancoin.svg"
                      width={15}
                      height={15}
                    />
                    Get more credits
                  </button>
                </div>
                <div className="mt-4 rounded-2xl border border-gray-200 p-4">
                  <h3 className="mb-4 text-sm font-semibold text-gray-700">
                    Usage Breakdown
                  </h3>
                  <div className="space-y-3">
                    {summary?.usageBreakDowns &&
                      summary?.usageBreakDowns.length > 0 &&
                      summary?.usageBreakDowns.map(b => (
                        <div key={b.name} className="flex items-center gap-3">
                          <div className="flex min-w-24 items-center gap-2">
                            <span
                              className={`h-1.5 w-1.5 rounded-full ${b.name === "Route Plan" ? "bg-yellow-500" : "bg-blue-500"}`}
                              aria-hidden
                            />
                            <span className="text-xs text-gray-600">
                              {b.name}
                            </span>
                          </div>

                          <div className="relative h-1.5 flex-1 rounded-full bg-gray-100">
                            <div
                              className="absolute inset-y-0 left-0 rounded-full"
                              style={{
                                width: `${b.usage}%`,
                                background:
                                  b.name === "Route Plan"
                                    ? "#facc15"
                                    : b.name === "Vahan Fetch"
                                      ? "#3b82f6"
                                      : "#111827"
                              }}
                            />
                          </div>
                          <div className="w-10 text-right text-xs text-gray-600">
                            {b.usage}%
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NeoModal
          actionType={actionType}
          onOpen={modalOpen}
          onClose={onModalClose}
          onModalSubmit={onModalSubmit}
          hasActions={false}
          data={modalData}
        ></NeoModal>
      </>
    </>
  );
};
